import type { DownloadNfseLotePayload, DownloadNfseLoteResponse } from '../types';

const DOWNLOAD_NFSE_LOTE_URL = 'https://services.impostograma.com.br/emalote-prod/download-em-lote';
const DOWNLOAD_NFSE_LOTE_AUTHORIZATION = 'RRwPrJsGdiwdWZ1CZj9srRtCdQ99LPeg';

export async function downloadNfseLoteApi(
  payload: DownloadNfseLotePayload
): Promise<DownloadNfseLoteResponse> {
  const response = await fetch(DOWNLOAD_NFSE_LOTE_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: DOWNLOAD_NFSE_LOTE_AUTHORIZATION,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const erro = await response.json().catch(() => null);
    throw new Error(erro?.message || 'Não foi possível gerar o download em lote de NFS-e.');
  }

  return response.json();
}
